<div [ngClass]="['ui-card', className]">
  <ng-content></ng-content>
</div>
